import React, {useEffect, useState} from "react";
// import PageHeader from "../../components/Header/PageHeader"; // удалено
import {useTranslation} from "react-i18next";
import {fetchWrapper} from "../../helpers";
import {useNavigate} from "react-router-dom";
import activeMic from "../icons/mic-on.svg";
import inactiveMic from "../icons/mic-off.svg";
import "./style.css";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {
    Layout, Row, Col, Card, Space, Typography, Button, Divider, Tabs, Select,
    Slider, Drawer, Empty, Avatar, Badge, DatePicker, message, notification, Input, Segmented
} from "antd";
import {
    ThunderboltOutlined, AudioOutlined, EyeOutlined, CalendarOutlined,
    LinkedinOutlined, InstagramOutlined, FacebookOutlined, SaveOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";

import {contentPlanActions, postActions, questionsActions} from "../../store";
import AudioRecorder from "audio-recorder-polyfill";
import i18n from "i18next";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {SETTINGS} from "../../constants/settings";
import {ImeanHeader} from "../../components/Header/Header";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

// Coerce i18n values into a displayable string
const ts = (key, fallback = "") => {
    // allow objects to come through, pick active language or first value
    const v = i18n?.t ? i18n.t(key, {returnObjects: true, defaultValue: fallback}) : fallback;
    if (typeof v === "string") return v;
    if (v && typeof v === "object") {
        return v[i18n.language] || v.en || Object.values(v)[0] || fallback;
    }
    return fallback;
};


export const GeneratePost = () => {
    const memoizedPostFormats = JSON.parse(localStorage.getItem('postFormats')) || undefined;
    window.MediaRecorder = AudioRecorder;
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tokens, setTokens] = useState({
        facebook: false,
        instagram: false,
        linkedin: false,
    });
    const [postDescription, setPostDescription] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [notificationApi, notificationContextHolder] =
        notification.useNotification();
    const getInputDatetime = () => {
        const d = new Date();
        return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, -5)
            .slice(0, -3);
    };
    const [date, setDate] = useState(() => getInputDatetime());
    const [sn, setSn] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [contentFormats, setContentFormats] = useState([]);
    const [selectedContentFormatId, setSelectedContentFormatId] = useState(null);
    const [selectedContentLangs, setSelectedContentLangs] = useState(memoizedPostFormats?.contentLangs || []);
    const [postModel, setPostModel] = useState(memoizedPostFormats?.postModel || SETTINGS.POST_MODEL.DEFAULT);
    const [postLength, setPostLength] = useState(memoizedPostFormats?.postLength || SETTINGS.POST_LENGTH.DEFAULT);
    const [postEmojis, setPostEmojis] = useState(memoizedPostFormats?.postEmojis || SETTINGS.POST_EMOJIS.DEFAULT);
    // console.log('postDescription', postDescription);
    const contentPlan = useSelector((obj) => obj.contentPlan.contentPlan);

    const [postLoading, setPostLoading] = useState(false);
    const [isMicActive, setIsMicActive] = useState(false);

    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);

    const selectedSet = React.useMemo(() => new Set(sn), [sn]);
    const openNotificationEndSubscribe = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/subscription-plans")}
                >
                    {ts("posts.goToRate")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: ts("functions.error"),
            description: ts("posts.limit"),
            btn,
            key,
        });
    };

    const openNotificationSocialNetwork = ({message, description}) => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/profile")}
                >
                    {ts("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: message || ts("functions.error"),
            description: description || ts("posts.unknownError"),
            btn,
            key,
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!postDescription.trim()) {
            message.warning(ts("functions.noText"))
            return;
        }
        if (postDescription.length > 2000) {
            message.error(ts("functions.maxTextLength", {limit: 2000}));
            return;
        }

        setPostLoading(true);

        const event = new Date(date);
        fetchWrapper
            .post(`${baseUrl}/post/save`, {
                description: postDescription,
                socialNetwork: sn.join(","),
                date: event.toISOString(),
                formatId: selectedContentFormatId,
                selectedContentLangs,
                postLength,
                postEmojis,
                postModel,
            })
            .then((res) => {
                navigate(`/create-post/${res.contentPlanId}`);
            })
            .catch((err) => {
                if (err === 'Достигнут лимит действий') {
                    openNotificationEndSubscribe();
                } else {
                    openNotification();
                }
                setPostLoading(false);
            });
    };

    const startRecording = () => {

        navigator.mediaDevices
            .getUserMedia({audio: true})
            .then((stream) => {
                setIsMicActive(true);
                const recorder = new MediaRecorder(stream);
                recorder.start();
                setMediaRecorder(recorder);
                recorder.addEventListener("dataavailable", (e) => {
                    message.loading(ts("functions.loading"));
                    const audioBlob = new Blob([e.data], {type: "audio/wav"});
                    const audioFile = new File([audioBlob], "recording.wav", {
                        type: "audio/wav",
                    });
                    const formData = new FormData();
                    formData.append("audio", audioFile);

                    axios({
                        method: "POST",
                        url: `${process.env.REACT_APP_API_URL}/upload-audio`,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        data: formData,
                    })
                        .then(
                            (data) =>
                                data.data &&
                                setPostDescription(
                                    (postDescription) => `${postDescription || ""}${data.data}`
                                )
                        )
                        .catch((error) => console.error(error));
                });
            })
            .catch((error) => {
                message.error(ts("functions.microphone"));
            });
    };

    const stopRecording = () => {
        mediaRecorder?.stop();
        // You might want to do something with the audio chunks here, like creating a blob and saving or playing it
        const audioBlob = new Blob(audioChunks, {type: "audio/wav"});
        // Resetting audio chunks after recording is stopped
        setAudioChunks([]);
        setIsMicActive(false);
        // Here, you could save the blob or do something else with it
    };

    const handleRememberOptionsPublicationFormats = () => {
        const memoValues = {
            postModel: postModel,
            postLength: postLength,
            postEmojis: postEmojis,
            contentLangs: selectedContentLangs,
        };
        localStorage.setItem('postFormats', JSON.stringify(memoValues));
        message.success(ts("functions.successfullySaved"));
    };

    useEffect(() => {
        return () => {
            mediaRecorder?.state === "recording" && mediaRecorder.stop();
        };
    }, [mediaRecorder]);

    const toggleMic = () => {
        if (isMicActive) {
            stopRecording();
        } else {
            startRecording();
        }
    };

    const onChangeTextarea = (e) => {
        setPostDescription(e.target.value);
    };

    const handleChangeSocialNetworks = (value) => {
        const key = value.toLowerCase();
        if (!tokens[key]) {
            return openNotificationSocialNetwork({
                message: ts("functions.error"),
                description: ts(`posts.notLinked-${key}`),
            });
        }
        setSn(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
    };

    const handleChangeGeneratedLangs = (value) => setSelectedContentLangs(value);

    const onChangeFormatsCheckboxes = (e) => {
        e.stopPropagation();
        const { id } = e.target;
        setSelectedContentFormatId(prev => prev === id ? null : id);
    };

    // Fetch tokens once
    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then(res => {
                const filteredToken = { facebook:false, instagram:false, linkedin:false };
                res.forEach(token => {
                    if (token.socialMediaType === 'FACEBOOK') filteredToken.facebook = true;
                    if (token.socialMediaType === 'INSTAGRAM') filteredToken.instagram = true;
                    if (token.socialMediaType === 'LINKEDIN') filteredToken.linkedin = true;
                });
                setTokens(filteredToken);
                setSn(filteredToken.linkedin ? ['LinkedIn'] : []); // авто‑выбор LinkedIn если доступен
            })
            .catch(()=>{});
    }, []);

    // Fetch post formats once
    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/postformats`).then(res => setContentFormats(res)).catch(()=>{});
    }, []);

    const toggleSN = (name) => {
        const map = {LinkedIn:'linkedin', Instagram:'instagram', Facebook:'facebook'};
        if (!tokens[map[name]]) {
            openNotificationSocialNetwork({
                message: ts('functions.error'),
                description: ts(`posts.notLinked-${map[name]}`)
            });
            return;
        }
        setSn(prev => prev.includes(name) ? prev.filter(v => v !== name) : [...prev, name]);
    };

    const openNotification = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate('/support')}>Tech support</Button>
            </Space>
        );
        notificationApi.open({
            message: ts('functions.error'),
            description: ts('posts.unknownError'),
            btn,
            key,
        });
    };

    return (
        <Layout style={{minHeight: '100vh', background: 'linear-gradient(180deg, #ffffff, #faf5ff)'}}>
            {/* Глобальный Header */}
            <ImeanHeader initialDark={true}/>
            {/* Панель действий */}
            <div style={{ position:'sticky', top:0, zIndex:19, background:'rgba(255,255,255,0.85)', backdropFilter:'blur(6px)', borderBottom:'1px solid #f0f0f0', padding:'8px 16px' }}>
                <Row align="middle" justify="space-between" style={{maxWidth:1200, margin:'0 auto', width:'100%'}}>
                    <Space align="center" size={12}>
                        <Badge color="#7c3aed" />
                        <Typography.Title level={4} style={{margin:0}}>{t('postPage.cards.postTitle')}</Typography.Title>
                    </Space>
                    <Space>
                        <Button onClick={() => navigate('/posts')}>{t('functions.previous')}</Button>
                        <Button type={isMicActive ? 'primary':'default'} ghost={isMicActive} onClick={toggleMic} icon={<AudioOutlined/>}>
                            {isMicActive ? t('postPage.buttons.stopRecording') : t('postPage.buttons.startRecording')}
                        </Button>
                        <Button type="primary" icon={<ThunderboltOutlined/>} loading={postLoading} onClick={onSubmit} disabled={sn.length===0 || !postDescription.trim()}>
                            {t('postPage.buttons.generate')}
                        </Button>
                    </Space>
                </Row>
            </div>
            {/* CONTENT */}
            <Layout.Content style={{maxWidth:1200, margin:'24px auto', width:'100%', padding:'0 16px'}}>
                {contextHolder}
                {notificationContextHolder}
                <Row gutter={[16,16]}>
                    <Col xs={24} lg={14}>
                        <Card bordered className="shadow-sm" bodyStyle={{padding:16}}>
                            <Row align="middle" justify="space-between">
                                <Space size={12} align="center">
                                    <Typography.Title level={5} style={{margin:0}}>{t('postPage.cards.targetScheduleTitle')}</Typography.Title>
                                </Space>
                                <Space split={<Divider type="vertical"/>} style={{color:'#8c8c8c'}}>
                                    {sn.includes('Instagram') && <Space style={{color:'#1677ff'}}><InstagramOutlined/>Instagram</Space>}
                                    {sn.includes('LinkedIn') && <Space style={{color:'#1677ff'}}><LinkedinOutlined/>LinkedIn</Space>}
                                    {sn.includes('Facebook') && <Space style={{color:'#1677ff'}}><FacebookOutlined/>Facebook</Space>}
                                    <Space><CalendarOutlined/>{t('postPage.cards.when')}</Space>
                                </Space>
                            </Row>
                            <Divider style={{margin:'12px 0'}}/>
                            <Row gutter={[12,12]}>
                                <Col xs={24} md={12}>
                                    <Card size="small" bordered>
                                        <Space direction="vertical" style={{width:'100%'}}>
                                            <Typography.Text strong>{t('postPage.cards.platforms')}</Typography.Text>
                                            <Row gutter={[8,8]}>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Button block size="small" icon={<LinkedinOutlined/>} disabled={!tokens.linkedin} type={sn.includes('LinkedIn')?'primary':'default'} ghost={sn.includes('LinkedIn')} onClick={()=>toggleSN('LinkedIn')} style={{whiteSpace:'nowrap'}}>LinkedIn</Button>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Button block size="small" icon={<InstagramOutlined/>} disabled={!tokens.instagram} type={sn.includes('Instagram')?'primary':'default'} ghost={sn.includes('Instagram')} onClick={()=>toggleSN('Instagram')} style={{whiteSpace:'nowrap'}}>Instagram</Button>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Button block size="small" icon={<FacebookOutlined/>} disabled={!tokens.facebook} type={sn.includes('Facebook')?'primary':'default'} ghost={sn.includes('Facebook')} onClick={()=>toggleSN('Facebook')} style={{whiteSpace:'nowrap'}}>Facebook</Button>
                                                </Col>
                                            </Row>
                                            <Typography.Text type="secondary" style={{fontSize:12}}>{sn.length===0 ? t('postPage.cards.linkAcc'): null}</Typography.Text>
                                        </Space>
                                    </Card>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Card size="small" bordered>
                                        <Space direction="vertical" style={{width:'100%'}}>
                                            <Typography.Text strong>{t('postPage.cards.schedule')}</Typography.Text>
                                            <DatePicker showTime value={date ? dayjs(date): null} onChange={d=>setDate(d? d.format('YYYY-MM-DDTHH:mm'):'')} style={{width:'100%'}} />
                                            <Typography.Text type="secondary" style={{fontSize:12}}>{t('postPage.cards.localTime')}</Typography.Text>
                                        </Space>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                        <Card className="shadow-sm" style={{marginTop:16}} bodyStyle={{padding:16}}>
                            <Row justify="space-between" align="middle">
                                <Typography.Title level={5} style={{margin:0}}>{t('postPage.cards.whatPostSay')}</Typography.Title>
                                <Space split={<Divider type="vertical"/>}>
                                    <Typography.Text type="secondary">{t('postPage.cards.characters')}:</Typography.Text>
                                    <Typography.Text>{postDescription.length}/2000</Typography.Text>
                                </Space>
                            </Row>
                            <Divider style={{margin:'12px 0'}}/>
                            <Input.TextArea value={postDescription} onChange={onChangeTextarea} placeholder={t('postPage.placeholders.addDetails')} autoSize={{minRows:8,maxRows:14}} maxLength={2000} showCount />
                            <Space style={{marginTop:12}}>
                                <Button onClick={()=>setPostDescription('')}>{t('postPage.buttons.clear')}</Button>
                                <Button onClick={()=>setDrawerVisible(true)}>{t('postPage.buttons.settings')}</Button>
                                <Button type="primary" icon={<ThunderboltOutlined/>} onClick={onSubmit} loading={postLoading} disabled={sn.length===0 || !postDescription.trim()}>{t('postPage.buttons.generate')}</Button>
                            </Space>
                        </Card>
                        <Card className="shadow-sm" style={{marginTop:16}} bodyStyle={{padding:16}}>
                            <Space direction="vertical" style={{width:'100%'}} size={8}>
                                <Typography.Text type="secondary" style={{fontSize:12}}>{t('postPage.hint.hintText')}</Typography.Text>
                                <Space split={<Divider type="vertical"/>}>
                                    <Typography.Text type="secondary">{t('postPage.hint.shortcutSend')}</Typography.Text>
                                    <Typography.Text type="secondary">{t('postPage.hint.shortcutPaste')}</Typography.Text>
                                </Space>
                            </Space>
                        </Card>
                    </Col>
                    <Col xs={24} lg={10}>
                        <Card className="shadow-sm" bodyStyle={{padding:16}}>
                            <Row align="middle" justify="space-between">
                                <Typography.Title level={5} style={{margin:0}}>{t('postPage.cards.generationOptions')}</Typography.Title>
                                <Button onClick={handleRememberOptionsPublicationFormats} icon={<SaveOutlined/>}>{t('postPage.buttons.remember')}</Button>
                            </Row>
                            <Divider style={{margin:'12px 0'}}/>
                            <Space direction="vertical" style={{width:'100%'}}>
                                <Typography.Text strong>{t('postPage.cards.languagesPost')}</Typography.Text>
                                <Select mode="multiple" value={selectedContentLangs} onChange={setSelectedContentLangs} options={[{value:'ru',label:'Русский'},{value:'en',label:'English'},{value:'kk',label:'Қазақша'}]} style={{width:'100%'}} />
                                <Typography.Text strong>{t('postPage.cards.lengthPost')}</Typography.Text>
                                <Slider value={postLength} onChange={setPostLength} min={0} max={100} tooltip={{open:false}} />
                                <Typography.Text strong>{t('postPage.cards.emojisPost')}</Typography.Text>
                                <Select value={postEmojis} onChange={setPostEmojis} style={{width:'100%'}} options={[{value:'none',label:t('postPage.toolbar.emojisOptions.none')},{value:'few',label:t('postPage.toolbar.emojisOptions.few')},{value:'more',label:t('postPage.toolbar.emojisOptions.more')}]} />
                                <Typography.Text strong>{t('postPage.cards.modelPost')}</Typography.Text>
                                <Select value={postModel} onChange={setPostModel} style={{width:'100%'}} options={[{value:SETTINGS.POST_MODEL.DEFAULT,label:t('postPage.toolbar.modelOptions.default')},{value:'creative',label:t('postPage.toolbar.modelOptions.creative')},{value:'formal',label:t('postPage.toolbar.modelOptions.formal')}]} />
                            </Space>
                        </Card>
                    </Col>
                </Row>
                <Drawer title="Settings" open={drawerVisible} onClose={()=>setDrawerVisible(false)} width={420}>
                    <Space direction="vertical" style={{width:'100%'}}>
                        <Typography.Text type="secondary">Tune languages, length, emojis, and format before generating.</Typography.Text>
                    </Space>
                </Drawer>
            </Layout.Content>
        {/*Removed the footer at user request*/}
        </Layout>
    );
};
